<template>
  <div>
    <h3 v-if="showName" name="top" v-cloak>{{ tilpa.givenName }} {{ tilpa.familyName }}</h3>
    <div class="bests">
      <h4>{{ trans('Bests') }}</h4>

      <table class="table table-striped table-condensed" v-cloak>
          <thead>
              <tr>
                  <th>{{ trans('Event') }}</th>
                  <th>{{ trans('PB') }}</th>
                  <th v-for="year in displayYears">{{ year }}</th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="row in bestsByYearAndEvent">
                <td v-for="(cell, colIndex) in row"
                  >
                  <a 
                    v-if="typeof cell !== 'undefined' && cell[1]" 
                    :href="'#' + cell[1]" 
                    :class="{ pb: colIndex > 1 && (cell[0] == row[1][0]) }"
                    @click="highlight"
                    >
                  {{ typeof cell !== 'undefined' ? cell[0] : ''  }}
                  </a>
                  <span v-else>
                  {{ typeof cell !== 'undefined' ? cell[0] : ''  }}
                  </span>
                </td>
              </tr>
          </tbody>
      </table>
    </div>

    <div class="performances">
      <h4>{{ trans('Performances') }}</h4>
      <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
        <div class="panel panel-default" v-for="(perfs, index) in resultsByYear">
          <div class="panel-heading" role="tab" :id="'heading' + index">
            <a href="#top" class="pull-right text-muted"> <span class="glyphicon glyphicon-circle-arrow-up"></span><small class="sr-only">top</small></a>
            <a class="panel-title" role="button" data-toggle="collapse" data-parent="#accordion" :href="'#collapse' + index" aria-expanded="true" :aria-controls="'collapse' + index" :name="perfs[0].date.substr(0, 4)">
              {{ perfs[0].date.substr(0, 4) }}
            </a>
          </div>
          <div :id="'collapse'+ index" class="panel-collapse collapse in" role="tabpanel" :aria-labelledby="'heading' + index">
            <a name=""></a>
            <table class="table table-striped table-condensed" v-cloak>
              <thead>
                <tr>
                  <th>{{ trans('Date') }}</th>
                  <th>{{ trans('Discipline') }}</th>
                  <th>{{ trans('Result') }}</th>
                  <th>{{ trans('Rank') }}</th>
                  <th>{{ trans('Venue') }}</th>
                  <th>{{ trans('Category') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="perf in perfs">
                  <td>{{ new Date(perf.date).toLocaleDateString() }}</td>
                  <td :class="{indoor: perf.IndoorOutdoor == 'Indoor'}">{{ perf.event }}</td>
                  <td>
                    <a :name="perf.id">{{ perf.result }}
                    <span v-if="perf.wind"
                          :class="parseFloat(formatWind(perf.wind)) > 2.0 ? 'windy' : 'windOK'">
                            ({{ formatWind(perf.wind, true) }})
                    </span>
                    </a>
                  </td>
                  <td>{{ perf.rank }} <span v-if='perf.round'>({{ perf.round }})</span></td>
                  <td>{{ perf.city }}</td>
                  <td>{{ perf.agegroup }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <slot></slot>

  </div>
</template>

<script>
import _ from 'lodash'
import { betterPerformance, textDisciplineSortKey } from 'athlib'
import TranslationMixin from '../assets/TranslationMixin.js'

export default {
  mixins: [TranslationMixin],
  props: {
    url: String,
    showName: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      est_date_pattern: /\d{2}\.\d{2}\.\d{4}/,
      seasonBests: [],
      personalBests: [],
      results: [],
      dummy: '',
      tilpa: {}   // this gets loaded
    }
  },
  methods: {
    highlight: function (e) {
      var t = e.target
      var link = document.getElementsByName(t.href.split('#')[1])[0]
      var currs = document.getElementsByClassName('backYellow')
      if (currs.length) {
        currs[0].className = ''
      }
      link.parentNode.parentNode.className = 'backYellow'
      window.setTimeout(function () {
        window.scrollBy(0, -150)
      }, 250)
    },
    floatSort: function (obj) {
      if (obj.result) {
        obj.result_num = parseFloat(obj.result)
      } else {
        obj.result_num = 0
      }
      if (obj.rank) {
        obj.rank_num = parseFloat(obj.rank)
      } else {
        obj.rank_num = 0
      }
    },
    addEventSortKey: function (obj) {
      if (obj.event) {
        obj.eventKey = textDisciplineSortKey(obj.event)
      }
    },
    loadTilastopaja: function () {
      var self = this
      self.$http.get(self.url, {}).then((response) => {
        self.dummy = 'raw data'
        return response.json()
      }).then((data) => {
        self.dummy = 'json data'
        data = self.cleanTilpaData(data)
        self.tilpa = data
        if (data.hasOwnProperty('seasonbests')) {
          self.seasonBests = data.seasonbests
          _.each(self.seasonBests, self.floatSort)
          _.each(self.seasonBests, self.addEventSortKey)
        }
        if (data.hasOwnProperty('results')) {
          self.results = _.values(data.results)
          for (var i = 0; i < self.results.length; i++) {
            self.results[i].id = i
          }
          _.each(self.results, self.floatSort)
          _.each(self.results, self.addEventSortKey)
        }
        if (data.hasOwnProperty('personalbests')) {
          self.personalBests = data.personalbests
          _.each(self.personalBests, self.floatSort)
          _.each(self.personalBests, self.addEventSortKey)
        }
      })
    },
    cleanTilpaData: function (obj) {
      // var dateKeys = ['date', 'birthdate']
      var keysToRename = {
        'firstname': 'givenName',
        'lastname': 'familyName',
        'eventCode': 'event'
      }

      function cleanObject (o) {
        var build, key, destKey, value
        build = {}
        for (key in o) {
          destKey = keysToRename[key] || key
          value = o[key]
          if (typeof value === 'object') {
            value = cleanObject(value)
          }
          build[destKey] = value
        }
        return build
      }
      return cleanObject(obj)
    },
    distinctEvents: function () {
      var evs = {}
      var result
      var i
      for (i = 0; i < this.results.length; i++) {
        result = this.results[i]
        evs[result.eventKey] = result.event
      }

      return _(evs).toPairs().sortBy(0).fromPairs().values().value()
    },
    yearRange: function () {
      var i, earliest, latest, result, yyyy
      for (i = 0; i < this.results.length; i++) {
        result = this.results[i]
        yyyy = result.date.slice(0, 4)

        if (i === 0) {
          earliest = yyyy
          latest = yyyy
        } else {
          if (yyyy < earliest) { earliest = yyyy }
          if (yyyy > latest) { latest = yyyy }
        }
      }
      return [earliest, latest]
    },
    /** return the list of years in which they competed */
    years: function () {
      var yrs = []
      var rng = this.yearRange()
      var earliest = parseInt(rng[0])
      var latest = parseInt(rng[1])

      for (var yyyy = latest; yyyy >= earliest; yyyy--) {
        yrs.push(yyyy.toString())
      }
      return yrs
    },
    windy: function (wind) {
      return (parseFloat(wind) > 2.0)
    },
    formatWind: function (wind, includePlus = false) {
      wind = wind.replace('++', '')
      wind = wind.replace('+', '')
      // brackets, red if illegale
      if (includePlus && parseFloat(wind) > 0) wind = '+' + wind

      return wind
    }
  },
  computed: {
    resultsByYear: function () {
      var self = this
      var out = {}
      var result = []
      var yr = null
      _.each(self.results, function (row) {
        yr = row.date.substr(0, 4)
        if (out.hasOwnProperty(yr)) {
          out[yr].push(row)
        } else {
          out[yr] = [row]
        }
      })
      out = Object.values(out)
      out = _.orderBy(out, function (obj) { return obj[0].date }, 'desc')

      _.each(out, function (obj, index) {
        result.push(obj)
      })

      return result
    },
    displayYears: function () {
      return this.years()
    },
    /** Working matrix of best in a given year */
    bestsByYearAndEvent: function () {
      var yearlyBests = {}
      var lifetimeBests = {}
      var evs, ev, yyyy, result, i, perf
      for (i = 0; i < this.results.length; i++) {
        result = this.results[i]
        if (result.okForSB) {
          ev = result.event
          perf = result.result
          yyyy = result.date.slice(0, 4)
          // now check if it's an improvement
          // field events take the highest, running the lowest
          if ([ev, yyyy] in yearlyBests) {
            if (perf === betterPerformance(yearlyBests[[ev, yyyy]][0], perf, ev)) {
              // update the season's best
              yearlyBests[[ev, yyyy]] = [perf, result.id]
            }
          } else {
            // add an initial season's best
            yearlyBests[[ev, yyyy]] = [perf, result.id]
          }

          if (ev in lifetimeBests) {
            if (perf === betterPerformance(lifetimeBests[ev][0], perf, ev)) { // update lifetime best
              lifetimeBests[ev] = [perf, result.id]
            }
          } else {
            // create a lifetime best
            lifetimeBests[ev] = [perf, result.id]
          }
        }
      }
      // now tabulate the lot
      var rows = []
      var row, yrs

      yrs = this.years()
      evs = this.distinctEvents()
      for (i = 0; i < evs.length; i++) {
        ev = evs[i]
        row = [[ev, false]]
        row.push(lifetimeBests[ev] || ['-', false])
        for (yyyy of yrs) {
          row.push(yearlyBests[[ev, yyyy]])
        }
        rows.push(row)
      }
      return rows
    }

  },
  created: function () {
    var self = this
    self.dummy = 'loading'
    self.loadTilastopaja()
    self.dummy = 'loaded'
  }
}
</script>

<style src="../assets/table.css" scoped></style>
<style scoped>
  .bests .table {
    width: auto;
    max-width: 650px;
    min-width: 450px;
  }
  .bests .table > thead:first-child > tr:first-child > th {
    padding: .3em .2em
  }
  .bests .table td:nth-child(1) {
    padding: .3em .1em .3em 0 !important
  }
  .bests .table td:nth-child(n+2) {
    padding: .3em .2em .3em .1em !important;
    text-align: right
  }
  .bests td:nth-child(2) {
    background-color: #cce
  }
  .pb {
    color: #0c0; font-weight: bold;
  }

  [v-cloak] { display: none }
  #accordion {
    width: 450px
  }
  #accordion td:nth-child(1), #accordion td:nth-child(3), #accordion td:nth-child(4) {
    text-align: right
  }
  #accordion .panel-heading {
    padding: .4em 1em;
  }
  .backYellow {
    background-color: #ff0 !important
  }
  #accordion td:nth-child(2) {
    text-align: left
  }
  .windy { color: red; font-style: italic; }
  .windOK { color: green; font-style: italic; }
</style>



// WEBPACK FOOTER //
// TilpaAthleteStats.vue?55b3a5e1